
export const storageAdminI18n = {
  en: {
    title: 'Subjects',
    clear: 'Clear',
    cleared: 'Cleared',
    localStorage: 'Local Storage',
    localStorageDisclamer: 'Clear all the data stored locally in the browser related to subject builder and calendars.'
  },
  es: {
    title: 'Cursos',
    clear: 'Limpiar',
    cleared: 'Limpiado',
    localStorage: 'Almacenamiento local',
    localStorageDisclamer: 'Puedes limpiar toda la data que se encuentra localmente en el browser relacionada a subject builder y calendarios.'
  }
}